/** ч.1303: друкована форма → Excel (опис аркуша збирає сторінка, книгу складає сервер). */
import { api } from './client';
import { filenameFromDisposition } from './documents';
import type { PrintXlsxPayload } from '@/shared/utils/printToXlsx';
import type { InvoiceXlsxPayload } from '@/shared/utils/invoicePrintModel';

export const printExport = {
  xlsx: async (payload: PrintXlsxPayload): Promise<{ blob: Blob; filename: string }> => {
    const r = await api.post<Blob>('/print/xlsx', payload, { responseType: 'blob' });
    return {
      blob: r.data,
      filename: filenameFromDisposition(r.headers?.['content-disposition'], `${payload.filename}.xlsx`),
    };
  },
  /** ч.1373: рахунок на оплату — книга на сітці 1С (`services/print_invoice_xlsx.py`). */
  invoiceXlsx: async (payload: InvoiceXlsxPayload): Promise<{ blob: Blob; filename: string }> => {
    const r = await api.post<Blob>('/print/xlsx/invoice', payload, { responseType: 'blob' });
    return {
      blob: r.data,
      filename: filenameFromDisposition(r.headers?.['content-disposition'], `${payload.filename}.xlsx`),
    };
  },
};
